import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/namedquery`;

export class NamedQuery {
  static async getAll(params = {}) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getMax(params = {}) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/max`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getByName(name, params = {}) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}`, {
        headers: Contexture.getHeaders(profileId),
        params: {
          ...params,
          name,
        },
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async create(namedQueryData, params = {}) {
    try {
      const profileId = params?.profileId;
      const response = await axios.post(`${BASE_URL}`, namedQueryData, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async update(name, namedQueryData, params = {}) {
    try {
      const profileId = params?.profileId;
      const response = await axios.put(`${BASE_URL}/${encodeURIComponent(name)}`, namedQueryData, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async delete(name, params = {}) {
    try {
      const profileId = params?.profileId;
      const response = await axios.delete(`${BASE_URL}`, {
        headers: Contexture.getHeaders(profileId),
        params: {
          ...params,
          name,
        },
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }
}
